import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ErrorPage from './ErrorPage';
import { User } from './models/workday';
import data from './data/workday.json';
import Logging from './logging/sentry';
import { addDays } from './utils/dateTime';

Logging.initialize();

const rootEl = document.getElementById('root');
if (!rootEl || rootEl instanceof HTMLElement === false)
  throw Error('root element not found');

let user: User;
if (process.env.NODE_ENV === 'production') {
  const userstring = rootEl.dataset.user;
  if (!userstring) {
    user = {} as any;
  } else {
    user = JSON.parse(userstring);
  }
} else {
  user = JSON.parse(JSON.stringify(data));
  if (process.env.REACT_APP_RUNTESTS?.trim() === 'true') {
    user.Workdays.map((wd, i) => (wd.WdyDate = addDays(i)))
  }
}

ReactDOM.render(
  <React.StrictMode>
    {user! && <App user={user} />}
    {!user && <ErrorPage />}
  </React.StrictMode>,
  rootEl,
);
